module.exports = __webpack_public_path__ + "img/signal-animation.f45032ef.png";